import { http } from '@/utils/index'

/**
 * 分销商相关API
 */

// 查询所有启用的分销商（用于地图展示）
export function getEnabledDistributors() {
  return http.request('get', '/distributor/enabled', {})
}

// 根据省份查询启用的分销商
export function getDistributorsByProvince(province) {
  return http.request('get', `/distributor/province/${province}`, {})
}

// 根据城市查询启用的分销商
export function getDistributorsByCity(city) {
  return http.request('get', `/distributor/city/${city}`, {})
}

// 统计各省份分销商数量
export function getProvinceStatistics() {
  return http.request('get', '/distributor/statistics/province', {})
}

// 统计各等级分销商数量
export function getLevelStatistics() {
  return http.request('get', '/distributor/statistics/level', {})
}

// 根据ID查询分销商详情
export function getDistributorById(id) {
  return http.request('get', `/distributor/${id}`, {})
}
